import {ErrorState, ErrorStateDataHooks} from '../../../common/components/Layout/ErrorState/ErrorState';
import React from 'react';
import {useControllerProps} from '../Widget/ControllerContext';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {ChevronLeft} from '@wix/wix-ui-icons-common/on-stage';
import {Button} from 'wix-ui-tpa/cssVars';
import {classes} from './CheckoutErrorState.st.css';

export const CheckoutErrorState = ({hasPremiumError}: {hasPremiumError: boolean}) => {
  const {navigationStore} = useControllerProps();
  const localeKeys = useLocaleKeys();

  if (hasPremiumError) {
    return (
      <ErrorState
        title={localeKeys.checkout.paymentNotConnected.error.title()}
        subtitle={localeKeys.checkout.paymentNotConnected.error.message()}
        ctaButton={
          <Button
            as={'a'}
            data-hook={ErrorStateDataHooks.Button}
            href={navigationStore?.continueShoppingUrl}
            prefixIcon={<ChevronLeft />}
            className={classes.button}
            onClick={() => navigationStore?.clickOnContinueShopping()}>
            {localeKeys.checkout.currencyNotSupported.error.cta()}
          </Button>
        }
      />
    );
  }

  return <ErrorState onClick={navigationStore?.clickOnRefreshErrorState} />;
};
